import { t } from "i18next";
import { toast } from "react-hot-toast";
import { Modal } from "ui";

import { useDeleteDriver, useRestoreDriver } from "../../../apis";
import { ChangeDriverDeleteStatusModalProps } from "./ChangeDriverDeleteStatusModal.types";

import styles from "./ChangeDriverDeleteStatusModal.module.scss";

const ChangeDriverDeleteStatusModal = ({
  isOpen,
  id,
  action,
  onClose
}: ChangeDriverDeleteStatusModalProps) => {
  const restoreDriver = useRestoreDriver({
    onSuccess: () => {
      onClose();
      toast.success(t("Driver has been restored successfully"));
    }
  });

  const deleteDriver = useDeleteDriver({
    onSuccess: () => {
      onClose();
      toast.success(t("Driver has been deleted successfully"));
    }
  });

  const onOkClick = () => {
    if (action === "Delete") {
      deleteDriver.mutate(id);
    } else {
      restoreDriver.mutate(id);
    }
  };

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title={t(`${action} Driver`)}
      isLoading={deleteDriver.isLoading || restoreDriver.isLoading}
      okText={action}
      onOk={onOkClick}
      contentClassName={styles.deleteDriverModal}
      onClose={onClose}
    >
      <p className={styles.deleteDriverModal_text}>
        {t(`Are you sure you want to ${action.toLowerCase()} this driver?`)}
      </p>
    </Modal>
  );
};

export default ChangeDriverDeleteStatusModal;
